export default {
    "Van Cranenbroek": "Van Cranenbroek",
    "Menu": "Menu",
    "What are you looking for?": "Que cherchez-vous?",
    "back": "retour",
    "Filtering": "Filtrage",
    "Clear all": "Tout effacer",
    "Show more": "Afficher plus",
    "Show less": "Afficher moins",
    "Price": "Prix",
    "to": "\u00e0",
    "Enter a correct value": "Entrez une valeur correcte",
    "Popularity": "Popularit\u00e9",
    "Newest": "Plus r\u00e9cent",
    "Name (A-Z)": "Nom (A-Z)",
    "Name (Z-A)": "Nom (Z-A)",
    "Price (Ascending)": "Prix (Croissant)",
    "Price (Descending)": "Prix (D\u00e9croissant)",
    "Categories": "Cat\u00e9gories",
    "Apply": "Appliquer",
    "No products were found in this category.": "Aucun produit n'a \u00e9t\u00e9 trouv\u00e9 dans cette cat\u00e9gorie.",
    "More info": "Plus d'infos",
    "Subscribe to our newsletter": "Abonnez-vous \u00e0 notre newsletter",
    "Yes i subscribe!": "Oui je m'abonne!",
    "Follow us": "Suivez-nous",
    "Show store": "Afficher le magasin",
    "Quick access to": "Acc\u00e8s rapide \u00e0",
    "In stock in {count} store(s)": "En stock dans {count} magasin(s)",
    "Out of stock": "En rupture de stock",
    "In stock": "En stock"
}